"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var axios_1 = __importDefault(require("axios"));
var react_1 = require("react");
require("./styles.css");
var loading_svg_1 = __importDefault(require("./static/loading.svg"));
var SiteTabSearchResults_1 = __importDefault(require("@component/SiteTabSearchResults"));
function ToQueryString(searchTerm) {
    if (typeof document !== "undefined" && typeof window !== "undefined") {
        var urlSearchParams = new URLSearchParams(location.search);
        urlSearchParams.set("q", searchTerm);
        window.history.replaceState({}, "", location.pathname + "?" + urlSearchParams);
    }
}
function getUrlParameter(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    var results = regex.exec(location.search);
    return results === null
        ? ""
        : decodeURIComponent(results[1].replace(/\+/g, " "));
}
var AssetExplorerSiteTab = function (props) {
    var _a = (0, react_1.useState)(0), skipVar = _a[0], setSkipVar = _a[1]; //results to skip for pagination
    var _b = (0, react_1.useState)(true), isLoading = _b[0], setisLoading = _b[1];
    var _c = (0, react_1.useState)({}), responseData = _c[0], setResponseData = _c[1];
    var _d = (0, react_1.useState)({}), filterSummary = _d[0], setFilterSummary = _d[1];
    var _e = (0, react_1.useState)([]), siteTabItems = _e[0], setSiteTabItems = _e[1];
    var _f = (0, react_1.useState)(1), startRange = _f[0], setStartRange = _f[1];
    var _g = (0, react_1.useState)(props.pageSize), endRange = _g[0], setEndRange = _g[1];
    var _h = (0, react_1.useState)(1), currentPage = _h[0], setCurrentPage = _h[1];
    var handleFilterSummary = function (startRange, endRange, totalCount, type, term, countText) {
        var result = {
            startAssetPageCount: startRange,
            assetPageCount: endRange,
            totalAssetCount: totalCount,
            assetType: type,
            searchTerm: term,
            resultCountText: countText,
        };
        setFilterSummary(result);
    };
    var handlePaginationChange = function (page) {
        var newSkipVar = (page - 1) * props.pageSize;
        var endRangeCount = newSkipVar + props.pageSize > responseData.ResultsCount
            ? responseData.ResultsCount
            : newSkipVar + props.pageSize;
        setSkipVar(newSkipVar);
        setStartRange(newSkipVar + 1);
        setEndRange(endRangeCount);
        setCurrentPage(page);
        handleFilterSummary(startRange, endRange, responseData.ResultsCount, "", props.searchTerm, props.resultCountText);
    };
    (0, react_1.useEffect)(function () {
        axios_1.default
            .get("api/sitecore/SitecoreSolrSearch/DoSearch?q=" +
            props.searchTerm +
            "&context=" +
            getUrlParameter("context") +
            "&cultureInfo=" +
            props.contextLanguage //getUrlParameter("cultureInfo")
        )
            .then(function (response) {
            var _a, _b, _c;
            setResponseData(response.data);
            var resultCount = (_a = response.data) === null || _a === void 0 ? void 0 : _a.ResultsCount;
            var eRange = resultCount < props.pageSize ? resultCount : props.pageSize;
            handleFilterSummary(1, eRange, resultCount, "", props.searchTerm, props.resultCountText);
            props.setTabCount((_b = response.data) === null || _b === void 0 ? void 0 : _b.ResultsCount);
            var responseArray = [];
            (_c = response.data) === null || _c === void 0 ? void 0 : _c.Results.map(function (result) {
                var t = "<h3>".concat(result === null || result === void 0 ? void 0 : result.Title, "</h3><a href='").concat(result === null || result === void 0 ? void 0 : result.Url, "'>").concat(result === null || result === void 0 ? void 0 : result.Url, "</a><p>").concat(result === null || result === void 0 ? void 0 : result.Description, "</p>");
                // setSiteTabItems((preValue: any) => [...preValue, t]);
                responseArray.push(t);
            });
            setSiteTabItems(responseArray);
            ToQueryString(props.searchTerm);
            setisLoading(false);
            setCurrentPage(1);
        })
            .catch(function (error) {
            console.error(error);
            setisLoading(true);
        });
    }, [props.searchTerm]);
    (0, react_1.useEffect)(function () {
        if (responseData !== undefined) {
            handlePaginationChange(currentPage);
        }
    }, [skipVar]);
    if (isLoading) {
        return (0, jsx_runtime_1.jsx)("img", { src: loading_svg_1.default, width: "5%", height: "auto", alt: "" });
    }
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: !isLoading && ((0, jsx_runtime_1.jsx)(SiteTabSearchResults_1.default, { filterSummary: filterSummary, siteTabItems: siteTabItems, pageSize: props.pageSize, pageLabel: props.pageLabel, pageChange: handlePaginationChange, currentPage: currentPage, noResultText: props.noResultText })) }));
};
exports.default = AssetExplorerSiteTab;
//# sourceMappingURL=site-tab.js.map